import React from 'react'

import { connect } from 'react-redux'
import { reduxForm, startSubmit } from 'redux-form'
import { Prompt } from 'react-router-dom'
import { appUpdateRequest } from '../../actions'

import { Box } from 'components/Layout'
import { Form, FormError } from 'components/Form'
import { SaveButton } from 'components/Button'
import { BoxShell } from 'components/Shells'

import { AppIsPendingReviewBanner } from '../../views/Banners'

import {
	appNameValidator,
	appShortDescValidator,
	appDescValidator,
	appIconValidator
	// appTutorialUrlValidator
} from './validators.js'
import FieldSection from './FieldSection.js'
import { TEXT, TEXTAREA, APP_ICON } from './fieldTypes.js'

const AppDisplayForm = props => {
	const {
		dispatchSubmit,
		handleSubmit,
		submitting,
		dirty,
		app,
		change,
		error,
		readOnly,
		inReview
	} = props

	const fields = [
		{
			type: TEXT,
			name: 'name',
			fieldId: 'name',
			title: 'Name',
			description:
				'We like fancy names, but "asdf" will work for now. You can always change it later.',
			placeholder: 'Watermelon app',
			validate: appNameValidator,
			required: true,
			disabled: readOnly
		},
		{
			type: APP_ICON,
			name: 'iconUrl',
			fieldId: 'iconUrl',
			title: 'App icon',
			required: true,
			validate: appIconValidator,
			changeField: change,
			disabled: readOnly,
			customProps: {
				appId: app ? app.id : undefined
			}
		},
		{
			type: TEXT,
			name: 'shortDescription',
			fieldId: 'shortDescription',
			title: 'Short description',
			description: 'Let the user know what the app does in one sentence.',
			placeholder: 'Really short description',
			validate: appShortDescValidator,
			required: true,
			disabled: readOnly
		},
		{
			type: TEXTAREA,
			name: 'description',
			fieldId: 'description',
			title: 'Detailed description',
			description:
				'Make sure that description provides all the information the user needs to successfully use your app.',
			placeholder:
				'This app saves your life and not only life. It can also cook frogs in the oven.',
			validate: appDescValidator,
			required: true,
			disabled: readOnly
		}
		// {
		// 	type: TEXTAREA,
		// 	name: 'customData.descriptionInstallation',
		// 	fieldId: 'customData.descriptionInstallation',
		// 	title: 'Installation message',
		// 	description: 'A message displayed during the installation process.',
		// 	placeholder: "Brace yourself, I'm about to install!",
		// 	// validate: appNameValidator,
		// 	// required: true,
		// 	disabled: readOnly
		// },
		// {
		// 	type: TEXT,
		// 	name: 'customData.tutorialUrl',
		// 	fieldId: 'customData.tutorialUrl',
		// 	title: 'Tutorial URL',
		// 	description: 'A link to user guide or tutorial.',
		// 	placeholder: 'https://www.google.com/',
		// 	validate: appTutorialUrlValidator,
		// 	disabled: readOnly
		// }
	]

	if (typeof app === 'undefined') {
		return (
			<Form>
				<BoxShell height={100} />
				<BoxShell height={120} />
				<BoxShell height={220} />
			</Form>
		)
	}

	return (
		<Form handleSubmit={handleSubmit(dispatchSubmit)}>
			<Prompt
				when={submitting || dirty}
				message={() =>
					`You've got unsaved changes. Are you sure you want to leave this page?`
				}
			/>
			<AppIsPendingReviewBanner appId={app.id} inReview={inReview} />
			<Box
				header={'App configuration'}
				body={fields.map(field => {
					return <FieldSection {...field} key={field.fieldId} />
				})}
				info={
					!readOnly ? (
						<span>
							{!submitting ? <FormError error={error} /> : null}
							<SaveButton submitting={submitting} dirty={dirty} />
						</span>
					) : (
						<span>App in review – read only</span>
					)
				}
			/>
		</Form>
	)
}

const mapStateToProps = (state, ownProps) => {
	const currentApp = state.apps.items[ownProps.match.params.appId]
	const readOnly = currentApp ? currentApp.status !== 'IN_DEVELOPMENT' : false
	const inReview = currentApp ? currentApp.status === 'IN_REVIEW' : false

	return {
		app: currentApp,
		readOnly,
		inReview,
		initialValues: currentApp || {
			customData: { name: currentApp ? currentApp.name : '' }
		}
	}
}

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		dispatchSubmit: values => {
			dispatch(startSubmit('appDisplay'))
			dispatch(
				appUpdateRequest({
					formName: 'appDisplay',
					...values
				})
			)
		}
	}
}

const ConnectedAppDisplayForm = connect(mapStateToProps, mapDispatchToProps)(
	reduxForm({
		form: 'appDisplay',
		touchOnBlur: false,
		enableReinitialize: true
	})(AppDisplayForm)
)

export default ConnectedAppDisplayForm



// WEBPACK FOOTER //
// ./src/containers/Forms/AppDisplayForm.js